export interface FieldError {
	field: string
	defaultMessage: string
}

type Field = Record<string, string[]>

export interface ApiError {
	message: string
	title: string
	redirect: boolean
	fieldErrors: FieldError[]
}

export default class ApiResponseError extends Error {
	private readonly _title: string
	private readonly _redirect: boolean
	private readonly _errors: Field = {}

	constructor({ message, title, redirect, fieldErrors }: ApiError) {
		super(message)
		this._title = title
		this._redirect = redirect
		this._errors = {}
		if (fieldErrors && fieldErrors.length > 0) {
			fieldErrors.forEach(error => {
				this._errors[error.field] = [error.defaultMessage]
			})
		}
	}

	get title(): string {
		return this._title
	}

	get redirect(): boolean {
		return this._redirect
	}

	get errors(): Field {
		return this._errors
	}
}
